/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { number } from 'prop-types';

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 10,
        borderRadius: 5,
    },
    colorPrimary: {
        border: `1px solid ${theme.palette.grey3}`,
        backgroundColor: theme.palette.white,
    },
    bar: {
        borderRadius: 5,
        backgroundColor: theme.palette.grey3,
    },
}))(LinearProgress);

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
});

function LinearProgressBar({ value }) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <BorderLinearProgress variant="determinate" value={value} />
        </div>
    );
}

LinearProgressBar.propTypes = {
    value: number.isRequired,
};

export default LinearProgressBar;
